
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_42863","data-name":"Group 42863","xmlns":"http://www.w3.org/2000/svg","width":"6.729","height":"13.984"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-skipped-block"}},[_c('rect',{attrs:{"id":"Rectangle_14188","data-name":"Rectangle 14188","width":"6.729","height":"13.984","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_42862","data-name":"Group 42862","clip-path":"url(#clip-path-skipped-block)"}},[_c('path',{attrs:{"id":"Path_29817","data-name":"Path 29817","d":"M.75 13.234V9.267c1.473 0 5.229.71 5.229-2.7C5.979 3.3 2.223 3.934.75 3.934V.75","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    